'use strict';

export * from './profile';



// WEBPACK FOOTER //
// ./src/js/user-profile/actions/index.js